//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import GegevensWijzigen from './MijnAccount/GegevensWijzigen.vue';
export default {
  name: 'MijnAccount',
  components: {
    GegevensWijzigen,
  },
  props: {
    expert: String,
    ajax: String,
  },
  data: function(){
    return {
      tab: 'gegevens-wijzigen',
    };
  },
}



// WEBPACK FOOTER //
// ./scripts/vue/MijnAccount.vue